import { Component } from "react";
import QrReader from "react-qr-scanner";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";

class QRCodeTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            delay: 250,
            resolution: 600,
            track: null,
            torchLightOn: false,
        };

        this.handleScan = this.handleScan.bind(this);
        this.handleError = this.handleError.bind(this);
    }

    componentDidMount() {
        navigator.mediaDevices
            .getUserMedia({
                video: {
                    facingMode: "environment",
                },
            })
            .then((stream) => {
                let track = stream.getVideoTracks()[0];
                this.setState({ track: track });
            })
            .catch((err) => console.error("getUserMedia() failed: ", err));
    }

    componentWillUnmount() {
        if (this.state.torchLightOn) this.switchTorchState();

        if (this.state.track) this.state.track.stop();

        this.setState({ track: null });
    }

    clearResult() {
        this.setState({
            result: null,
        });
    }

    switchTorchState() {
        if (!this.state.track) return;

        let capabilities = this.state.track.getCapabilities();

        if (capabilities.torch) {
            this.state.track
                .applyConstraints({
                    advanced: [{ torch: !this.state.torchLightOn }],
                })
                .catch((e) => console.error(e));
        }

        this.setState({ torchLightOn: !this.state.torchLightOn });
    }

    handleError(err) {
        console.error(err);
    }

    handleScan(data) {
        if (data && this.state.result !== data) {
            if (this.state.torchLightOn) this.switchTorchState();

            this.setState({
                result: data,
            });

            if (data !== null) {
                this.props.componentPark(data);
            }
        }
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding">
                <QrReader
                    constraints={{ facingMode: "environment" }}
                    id="qr-code-reader"
                    delay={this.state.delay}
                    resolution={this.state.resolution}
                    onError={this.handleError}
                    onScan={this.handleScan}
                    style={{ width: "100%" }}
                />
                <Fab onClick={this.switchTorchState.bind(this)} className="div-center">
                    <Icon>highlight</Icon>
                </Fab>
            </div>
        );
    }
}

export default QRCodeTab;
